export default "__VITE_ASSET__IGiBe8NU__"